module.exports = __webpack_public_path__ + "img/1512078671.e58b9a75.jpg";